import { render } from "./layout-without-header.vue?vue&type=template&id=7d98fc2e"
import script from "./layout-without-header.vue?vue&type=script&lang=js"
export * from "./layout-without-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__